/*
 * @Author: gaobin
 * @Date: 2025-07-31 17:18:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-04 14:09:18
 * @Description: 路由加载速度埋点
 */
import { eventTracker } from '@utils/eventTracker.js';
import { nextTick } from 'vue';

class RoutePerformance {
  constructor() {
    this.startTime = 0;
    this.endTime = 0;
  }

  // 发送页面渲染计时埋点
  sendPageTimeD(typeText, loadTime) {
    // 获取当前页面栈
    const newUrl = new URL(window.location.href); // 获取当前URL
    const pageUrl = newUrl.pathname === '/' ? 'pages/home/index' : newUrl.pathname;
    // console.log('当前路由', pageUrl);
    const params = [
      {
        pageUrl: `${pageUrl}/${typeText}`,
        spm: loadTime,
        action: 'time',
      },
    ];
    eventTracker.addPagePvTracker(params);
    customRP.clearAllTime();
  }

  // 页面初始化
  initListeners() {
    // this.startTime = performance.timing.navigationStart;
    console.log('统计页面加载时间', this.startTime, performance.now());
    // window.logInfo.whiteScreenTime = +new Date() - window.logInfo.openTime;
    // console.log('window.logInfo.whiteScreenTime', window.logInfo.whiteScreenTime);
    document.addEventListener('DOMContentLoaded', function (event) {
      const loadTime = +new Date() - performance.timing.navigationStart;
      console.log('DOMContentLoaded', loadTime);
      // this.sendPageTimeD('页面初始化');
      customRP.sendPageTimeD('页面初始化', loadTime);
    });

    // window.onload = function () {
    //   window.logInfo.allloadTime = +new Date() - window.logInfo.openTime;
    //   window.logInfo.nowTime = new Date().getTime();
    //   const timname = {
    //     whiteScreenTime: '白屏时间',
    //     loadTime: '用户可操作时间',
    //     allloadTime: '总下载时间',
    //     mobile: '使用设备',
    //     nowTime: '时间',
    //   };
    //   // let logStr = '';
    //   for (const i in timname) {
    //     console.log(`${timname[i]}:${window.logInfo[i]}ms`);
    //     //   if (i === 'mobile') {
    //     //     logStr += `&${i}=${window.logInfo[i]}`;
    //     //   } else {
    //     //     logStr += `&${i}=${window.logInfo[i]}`;
    //     //   }
    //   }
    //   // new Image().src = `/action?${logStr}`;
    // };

    // // Log all resource entries at this point
    // const resources = performance.getEntriesByType('resource');
    // resources.forEach((entry) => {
    //   console.log(`${entry.name}'s duration: ${entry.duration}`);
    // });

    // // PerformanceObserver version
    // // Log all resource entries when they are available
    // function perfObserver(list, observer) {
    //   list.getEntriesByType('resource').forEach((entry) => {
    //     console.log(`${entry.name}'s duration: ${entry.duration}`);
    //   });
    // }
    // const observer = new PerformanceObserver(perfObserver);
    // observer.observe({ entryTypes: ['resource', 'navigation'] });
  }

  // 路由切换
  routeChangeListeners() {
    this.startTime = performance.now();
    // 检测DOM更新完成
    new MutationObserver((mutations, observer) => {
      nextTick(() => {
        setTimeout(() => {
          this.endTime = performance.now();
          const loadTime = this.endTime - this.startTime;
          console.log(`当前路由渲染完成时间: ${loadTime}ms`);
          observer.disconnect();
          customRP.sendPageTimeD('页面切换', loadTime);
        }, 0);
      });
    }).observe(document, {
      childList: true,
      subtree: true,
    });
  }

  // 清空重新计算
  clearAllTime() {
    this.startTime = 0;
    this.endTime = 0;
  }
}

// 初始化
export const customRP = new RoutePerformance();
